import { render } from "./AvgWaitTime.vue?vue&type=template&id=5134f2bc"
import script from "./AvgWaitTime.vue?vue&type=script&lang=js"
export * from "./AvgWaitTime.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__